var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBumpersMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 490,
    height: 640,
    viewBox: "0 0 490 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.5C14 14.6716 14.6716 14 15.5 14H73.8642C74.2706 14 74.6595 14.1649 74.9421 14.4569L87.0389 26.9569C87.96 27.9087 87.2855 29.5 85.961 29.5H31C30.1716 29.5 29.5 30.1716 29.5 31V125.961C29.5 127.286 27.9087 127.96 26.9569 127.039L14.4569 114.942C14.1649 114.66 14 114.271 14 113.864V15.5Z",
    fill: "#BCD167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 623.5C14 624.329 14.6716 625 15.5 625H73.8642C74.2706 625 74.6595 624.836 74.9421 624.544L87.0389 612.044C87.96 611.092 87.2855 609.5 85.961 609.5H31.1368C30.3088 609.5 29.6374 608.83 29.6368 608.002L29.5054 449.525C29.5041 447.933 27.3496 447.44 26.6554 448.873L14.15 474.69C14.0513 474.894 14 475.118 14 475.344V623.5Z",
    fill: "#BCD167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475 16C475 15.1716 474.328 14.5 473.5 14.5H415.121C414.723 14.5 414.342 14.658 414.061 14.9393L402.061 26.9393C401.116 27.8843 401.785 29.5 403.121 29.5H458C458.828 29.5 459.5 30.1716 459.5 31V126.043C459.5 127.355 461.066 128.035 462.025 127.138L474.525 115.445C474.828 115.161 475 114.764 475 114.349V16Z",
    fill: "#BCD167"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M475 623.5C475 624.328 474.328 625 473.5 625H415.136C414.729 625 414.34 624.835 414.058 624.543L401.961 612.043C401.04 611.091 401.714 609.5 403.039 609.5H457.862C458.69 609.5 459.362 608.828 459.362 608V533.148L459.492 456.895C459.494 455.416 461.409 454.833 462.236 456.059L474.744 474.62C474.911 474.868 475 475.16 475 475.458V623.5Z",
    fill: "#BCD167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBumpersMobile);
export default __webpack_public_path__ + "static/media/bumpers_mobile.b5464409884037f09da325fbf7969815.svg";
export { ForwardRef as ReactComponent };